import { Typography } from "@mui/material"
import Dialog from "components/common/dialog/dialog"
import { useTranslation } from "react-i18next"

interface UnsavedChangesDialogProps {
  open: boolean
  isSaving: boolean
  onSave: () => void
  onDiscard: () => void
}

const UnsavedChangesDialog = ({
  open,
  isSaving,
  onSave,
  onDiscard,
}: UnsavedChangesDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      // Closing the warning (X) discards the changes
      onClose={isSaving ? undefined : onDiscard}
      titleText={t("addNewClass.unsavedChanges")}
      desktopMaxWidth="440px"
      tabletMaxWidth="440px"
      actionAcceptText={t("addNewClass.save")}
      onActionButtonClick={onSave}
      isLoading={isSaving}
      actionAcceptButtonProps={{ disabled: isSaving }}
    >
      <Typography variant="body1" color="mockup.neutral40">
        {t("addNewClass.unsavedChangesDescription")}
      </Typography>
    </Dialog>
  )
}

export default UnsavedChangesDialog
